export default "__VITE_ASSET__ChazIOUm__"